import type { SpaceResource } from "@octopusdeploy/octopus-server-client";
export const workflows = {
    addSpaceWorkflow: createDialogWorkflow<null, SpaceResource>("addSpaceWorkflow"),
};
function createDialogWorkflow<Input, Output>(workflowId: string): DialogWorkflow<Input, Output> {
    return {
        workflowId,
        workflowType: "dialog",
    };
}
function createDrawerWorkflow<Input, Output>(workflowId: string): DrawerWorkflow<Input, Output> {
    return {
        workflowId,
        workflowType: "drawer",
    };
}
export interface DialogWorkflow<Input, Output> {
    workflowId: string;
    workflowType: "dialog";
}
export interface DrawerWorkflow<Input, Output> {
    workflowId: string;
    workflowType: "drawer";
}
export type Workflow<Input, Output> = DialogWorkflow<Input, Output> | DrawerWorkflow<Input, Output>;
